import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useConfiguration from "../../../../hooks/useConfiguration";
import useSessionStorage from "../../../../hooks/useSessionStorage";
import {
  deleteEmpDocument,
  downloadEmpDocument,
  generateUploadRows,
  getEmpUploadedList,
  uploadEmpDocument,
} from "./action";
import { candidateSearchViewSelector } from "./selector";
import { useLocation } from "react-router-dom";
import { MdOutlineDeleteOutline } from "react-icons/md";
import "./employer_uploads.css"
import { setEmpUploadedList, setLoadingFlagDecrement, setLoadingFlagIncrement } from "./slice";
import * as Toasts from "../../../common/Toastify";
import { localHostBaseURL } from "../../../../helpers/domainURL";

const remainingUploads = 5;
const EmployerUploads = () => {
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const location = useLocation();
  const { userData } = location.state || {};
  const { empUploadedList } = useSelector(candidateSearchViewSelector);
  useEffect(() => {
    if (config.baseUrl) {
      dispatch(
        getEmpUploadedList({
          url: config.baseUrl,
          employerUniqueId: login.employerUniqueId,
          candidateUniqueId: userData?.candidateUniqueId,
        })
      );
    }
  }, [config.baseUrl]);

  const fileChangeHandler = (e, i) => {
    const file = e.target.files[0];
    const allowedFileSize = 10 * 1024 * 1024
    if(file){
      if(file?.size > allowedFileSize){
        Toasts.error('File size exceeds 10MB limit.')
        return;
      }
      dispatch(
        uploadEmpDocument({
          url: config.baseUrl,
          employerUniqueId: login.employerUniqueId,
          candidateUniqueId: userData?.candidateUniqueId,
          file,
          index: i,
        })
      ).then(() => dispatch(
        getEmpUploadedList({
          url: config.baseUrl,
          employerUniqueId: login.employerUniqueId,
          candidateUniqueId: userData?.candidateUniqueId,
        })
      ));
    }
  };

  const deleteUploadedDoc = (docId) => {
    dispatch(deleteEmpDocument({ url: config.baseUrl, docId })).then(() => dispatch(
      getEmpUploadedList({
        url: config.baseUrl,
        employerUniqueId: login.employerUniqueId,
        candidateUniqueId: userData?.candidateUniqueId,
      })
    ));
  };
  const downloadUploadDoc = async (filename, docId) => {
    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: login.accessToken ? `Bearer ${login.accessToken}` : "",
      "Website-Domain-Name":
        window.location.hostname === "localhost"
          ? localHostBaseURL
          : window.location.hostname ,
    };
    const params = {
    };
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await fetch(
        `${config.baseUrl}/Employers/download-employer-document?candidateEmployerUploadId=${docId}`,
        {
          headers: { ...requestHeaders },
          method: "POST",
          body: JSON.stringify(params),
        }
      );
      const blob = await response.blob();
      let downnloadURL = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = downnloadURL;
      a.download = filename;
      a.click();
    } catch (error) {
      Toasts.error(error.message);
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
  // const downloadUploadDoc = (filename, docId) => {
  //   // dispatch(downloadEmpDocument(config.baseUrl, docId))
  //   fetch(`${config.baseUrl}/Employers/download-employer-document?candidateEmployerUploadId=${docId}`)
  //     .then(response => {
  //       response.blob().then(blob => {
  //         let url = window.URL.createObjectURL(blob);
  //         let a = document.createElement('a');
  //         a.href = url;
  //         a.download = filename;
  //         a.click();
  //       });
  //     });
  // }
  const trimUploadName = (uploadName) => {
    let result = "";
    const endExt = uploadName.split(".");
    if (uploadName.length > 25) {
      const subResult = uploadName.substring(0, 25);
      result = subResult + "." + endExt[1];
    } else {
      result = uploadName;
    }
    return result;
  };
  const addmoreUploadHandler = () => {
   const responseUploads = generateUploadRows(empUploadedList, remainingUploads)
  dispatch(setEmpUploadedList(responseUploads));
  }
  return (
    <div className=" col-md-12 col-xl-12 ">
      <div>
        <div>
          <div className="PrintHeader">
            <h4 className="mb-0">Employer Uploads</h4>
          </div>
        </div>
        <div className="card-body">
          <div
            style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",columnGap:"0.5rem", rowGap:"1.25rem"}}
          >
            {empUploadedList?.map((upload, i) => {
              return (
                <React.Fragment key={i}>
                  {upload?.docId > 0 ? (
                    <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",columnGap:"0.25rem"}}>
                      <span
                        onClick={() => downloadUploadDoc(upload?.uploadedFileName, upload.docId)}
                        style={{ cursor: 'pointer', color: '#20851a', overflow:"auto" }}
                      >
                        {trimUploadName(upload?.uploadedFileName) ?? ""}
                      </span>
                      <span>
                      <i style={{ cursor: "pointer", fontSize: "1.25rem" }}
                        onClick={() => deleteUploadedDoc(upload.docId)} class="fe fe-trash-2" ></i>
                      </span>
                    </div>
                  ) : (
                    <div >
                      <div style={{ margin: "auto 0" }}>
                        <label htmlFor={`employer_${i}`} className="custom-file-upload">Choose File</label>
                        <input
                          id={`employer_${i}`}
                          className="file-upload"
                          name={`employer_${i}`}
                          type="file"
                          onChange={(e) => fileChangeHandler(e, i)}
                        />
                      </div>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
            <div>
            <button disabled={empUploadedList?.length === 80 ? true:false}  className="btn btn-primary sw-btn-next btnsmlbox"
                type="button" onClick={addmoreUploadHandler}>Add more</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployerUploads;
